import { mantleTestnetTokens } from '@pancakeswap/tokens'
import { FeeAmount, Pool } from '@pancakeswap/v3-sdk'
import { SerializedFarmConfig } from '..'
import { defineFarmV3Configs } from '../src/defineFarmV3Configs'

export const farmsV3 = defineFarmV3Configs([
  {
    pid: 1,
    token0: mantleTestnetTokens.mama,
    token1: mantleTestnetTokens.wbit,
    lpAddress: Pool.getAddress(mantleTestnetTokens.mama, mantleTestnetTokens.wbit, FeeAmount.LOW),
    feeAmount: FeeAmount.LOW,
  },
  {
    pid: 2,
    token0: mantleTestnetTokens.usdc,
    token1: mantleTestnetTokens.wbit,
    lpAddress: Pool.getAddress(mantleTestnetTokens.usdc, mantleTestnetTokens.wbit, FeeAmount.HIGH),
    feeAmount: FeeAmount.HIGH,
  },
  {
    pid: 3,
    token0: mantleTestnetTokens.usdt,
    token1: mantleTestnetTokens.usdc,
    lpAddress: Pool.getAddress(mantleTestnetTokens.usdt, mantleTestnetTokens.usdc, FeeAmount.LOWEST),
    feeAmount: FeeAmount.LOWEST,
  },
])

const farms: SerializedFarmConfig[] = []

export default farms
